import Vue from 'vue'
import AppAutosizeTextarea from '../../../components/AppAutosizeTextarea'
import AppDatetimePicker from '../../../components/AppDateTimePicker'
import AppTimePicker from '../../../components/AppTimePicker'

// TODO: 無駄が多いので整理したい
import {DatePicker, TimePicker} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import '../../../../../sass/common/element-variables.scss'
import ElementUIHelper from '../../../element-ui-helper'

locale.use(lang)

Vue.component("app-autoresize-textarea", AppAutosizeTextarea)
Vue.component("app-datetime-picker", AppDatetimePicker)
Vue.component("app-time-picker", AppTimePicker)

export default (data) => {
  data.disabled = data.mode === 'show'
  data.pickerOptions = ElementUIHelper.DatePickerOptions({btnToday:true})

  const vm = new Vue({
    el: '#net_insurance-content',
    data: data,
      methods: {

      },
    mounted: function() {
      if (data.disabled) {
        // TODO: とりあえずjQuery一括でやっているが個別にdisable属性をセットする
        $(':input').prop('disabled', true);
        $('input[type="button"],button[type="button"]').prop('disabled', false);
      }
    }
  })
}
